import { ping } from '@bedrock-rdk/utils';
import config from '@bedrock-rdk/config';
import { DEFAULT_IMAGE_LOAD_TIMEOUT_IN_SECONDS } from './pauseAds.constants';

export const track = urls => (urls ? urls.map(url => ping(url)) : []);

export const getImageLoadTimeout = () =>
  Number.isFinite(config.ads.pauseAdImageLoadTimeoutInSeconds)
    ? config.ads.pauseAdImageLoadTimeoutInSeconds
    : DEFAULT_IMAGE_LOAD_TIMEOUT_IN_SECONDS;
